import { Grid, Paper } from "@mui/material";
import CustomProgressBar from "components/CustomProgressBar";
import CustomText from "components/typography/CustomText";
import React from "react";

export default function FlavorBreakdown({ data = [] }) {
  const pies = data?.reduce((ret, cur) => [...ret, ...(cur?.pies ?? [])], []);
  const flavours = pies?.reduce((ret, cur) => {
    const checkPie = ret?.find((item) => item?.id === cur?.id);
    return checkPie
      ? ret
      : [
          ...ret,
          {
            ...cur,
            count: pies?.filter((item) => item?.id === cur?.id)?.length,
          },
        ];
  }, []);

  return (
    <Grid container spacing={2} elva>
      {flavours?.length > 0 ? (
        flavours?.map((item, index) => {
          const remain = Number((item.count * 100) % pies.length);
          const percent = Number((item.count * 100) / pies.length);
          return (
            <Grid item lg={2} md={3} sm={4} xs={12} key={index}>
              <Paper
                className="p-4 h-full flex justify-between flex-col bg-white"
                elevation={2}
              >
                <div className="flex justify-between items-center">
                  <CustomText className="flex-1">{item?.name}</CustomText>
                  <CustomText variant="h6" bold={600}>
                    {item?.count}
                  </CustomText>
                </div>
                <div className="flex w-full items-center">
                  <CustomText>
                    {!Boolean(remain) ? percent : percent.toFixed(2)}%
                  </CustomText>
                  <div className="flex-1 ml-1">
                    <CustomProgressBar
                      value={!Boolean(remain) ? percent : percent.toFixed(2)}
                      variant="determinate"
                    />
                  </div>
                </div>
              </Paper>
            </Grid>
          );
        })
      ) : (
        <div className="flex justify-center w-full mt-5">
          <CustomText className="text-center p-2" variant="h5">
            There is no Flavors
          </CustomText>
        </div>
      )}
    </Grid>
  );
}
